import TomSelect from 'tom-select';

export default class extends Controller {
  connect() {
    this.initializeTomSelect();
    document.addEventListener('turbo:load', this.initializeTomSelect);
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.initializeTomSelect);
  }

  initializeTomSelect = () => {
    console.log('Initializing Tom Select...');
    // Make sure to guard against initializing Tom Select multiple times
    if (!this.hasInitialized) {
      const selectElements = document.querySelectorAll('.tom-select-initialized');
      selectElements.forEach((element) => {
        if (!element._tomSelect) {
          new TomSelect(element, {
            // options
          });
        }
      });
      this.hasInitialized = true; // Prevent multiple initializations
    }
  };
}
